import getAxios from './axiosService'
import userService from './userService'

const homeService = {

  getIndexPage () {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get('/api/book/home/index')
        .then(res => {
          const resData = res.data
          if (resData.result) {
            resolve(resData)
          } else {
            console.error('Get index page with error', resData)
            reject(resData)
          }
        })
    })
  },
  getCommonInfo () {
    let branchId = userService.getBranchId();
    let url = '/api/common/info/v2/' + branchId;
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get(url)
        .then(res => {
          const resData = res.data
          if (resData.result) {
            resolve(resData)
          } else {
            console.error('Get index page with error', resData)
            reject(resData)
          }
        })
    })
  },
  bookInitSearch () {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get('/api/book/init_search')
        .then(res => {
          const resData = res.data
          if (resData.result) {
            resolve(resData)
          } else {
            console.error('Get index page with error', resData)
            reject(resData)
          }
        })
    })
  }
}

export default homeService
